export const allRoles = ['user', 'admin'] as const;

export type Role = (typeof allRoles)[number];

export const roleDescriptions: Record<Role, string> = {
  user: 'Standard access to the DocuMint web app.',
  admin: 'Access to the admin dashboard, including role management.',
};

export const buildRoleClaims = (roles: Role[]) => ({
  isAdmin: roles.includes('admin'),
  roles,
});
